@@ -0,0 +1,32 @@
<template>
  <div class="flex justify-center items-center p-10">
    <h2 class="text-center">Loading...</h2>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    if (this.$route.query.procedimiento && this.$route.query.tipo) {
      const procedimiento = this.$route.query.procedimiento;
      const tipo = this.$route.query.tipo;
      const valor = this.$route.query.valor ? this.$route.query.valor : "";

      const user = this.session.user;
      let urlToRedirect = "/";
      switch (procedimiento) {
        case "radicacion":
          switch (tipo) {
            case "queja":
            case "conciliacion":
            case "demanda":
              const user = this.session.user;
              let urlToRedirect = "/";
              if (user) {
                urlToRedirect = `/customer/complaint/registration?tipo=${tipo}`;
              } else {
                urlToRedirect = `/login?redireccion=sfc&procedimiento=${procedimiento}&tipo=${tipo}`;
              }
              this.$router.push(urlToRedirect).catch(() => {});
              break;
            default:
              this.$router.push("/").catch(() => {});
              break;
          }
          break;
        case "complaint-agiliza-cf":
          switch (tipo) {
            case "cierre-queja":
              if (user) {
                urlToRedirect = `/customer/complaint/tracking/detail/${valor}?type=agiliza`;
              } else {
                urlToRedirect = `/login?redireccion=sfc&procedimiento=${procedimiento}&tipo=${tipo}&valor=${valor}`;
              }
              this.$router.push(urlToRedirect).catch(() => {});
              break;
            case "confirm":
              if (user) {
                urlToRedirect = `/customer/complaint-agiliza/confirm/${valor}`;
              } else {
                urlToRedirect = `/login?redireccion=sfc&procedimiento=${procedimiento}&tipo=${tipo}&valor=${valor}`;
              }
              this.$router.push(urlToRedirect).catch(() => {});
              break;
            case "programacion-sesion":
            case "reprogramacion-sesion":
              if (user) {
                urlToRedirect = `/customer/complaint/tracking/detail/${valor}?type=agiliza&action=sesion`;
              } else {
                urlToRedirect = `/login?redireccion=sfc&procedimiento=${procedimiento}&tipo=${tipo}&valor=${valor}`;
              }
              this.$router.push(urlToRedirect).catch(() => {});
              break;
            case "revision-propuesta":
              if (user) {
                urlToRedirect = `/customer/complaint/tracking/detail/${valor}?type=agiliza&action=contrapropuesta`;
              } else {
                urlToRedirect = `/login?redireccion=sfc&procedimiento=${procedimiento}&tipo=${tipo}&valor=${valor}`;
              }
              this.$router.push(urlToRedirect).catch(() => {});
              break;
            default:
              this.$router.push("/").catch(() => {});
              break;
          }
          break;
        case "complaint-agiliza-ev":
          switch (tipo) {
            case "cierre-queja":
              if (user) {
                urlToRedirect = `/dashboard/complaints-agiliza/details?complaint_id=${valor}&type=agiliza`;
              } else {
                urlToRedirect = `/login?redireccion=sfc&procedimiento=${procedimiento}&tipo=${tipo}&valor=${valor}`;
              }
              this.$router.push(urlToRedirect).catch(() => {});
              break;
            case "contrapropuesta":
              if (user) {
                urlToRedirect = `/dashboard/complaints-agiliza/details?complaint_id=${valor}&type=agiliza&action=contrapropuesta`;
              } else {
                urlToRedirect = `/login?redireccion=sfc&procedimiento=${procedimiento}&tipo=${tipo}&valor=${valor}`;
              }
              this.$router.push(urlToRedirect).catch(() => {});
              break;
            case "programacion-sesion":
            case "reprogramacion-sesion":
              if (user) {
                urlToRedirect = `/dashboard/complaints-agiliza/details?complaint_id=${valor}&type=agiliza&action=sesion`;
              } else {
                urlToRedirect = `/login?redireccion=sfc&procedimiento=${procedimiento}&tipo=${tipo}&valor=${valor}`;
              }
              this.$router.push(urlToRedirect).catch(() => {});
              break;
            case "reporte-incumplimiento-facilitacion":
              if (user) {
                urlToRedirect = `/dashboard/complaints-agiliza/details?complaint_id=${valor}&type=agiliza&action=reporte-incumplimiento-facilitacion`;
              } else {
                urlToRedirect = `/login?redireccion=sfc&procedimiento=${procedimiento}&tipo=${tipo}&valor=${valor}`;
              }
              this.$router.push(urlToRedirect).catch(() => {});
              break;
            default:
              this.$router.push("/").catch(() => {});
              break;
          }
          break;
        case "complaint-agiliza-sfc":
          switch (tipo) {
            case "programacion-sesion":
            case "reprogramacion-sesion":
              if (user) {
                urlToRedirect = `/dashboard/complaints-agiliza/details?complaint_id=${valor}&type=agiliza&action=sesion`;
              } else {
                urlToRedirect = `/login?redireccion=sfc&procedimiento=${procedimiento}&tipo=${tipo}&valor=${valor}`;
              }
              this.$router.push(urlToRedirect).catch(() => {});
              break;
            default:
              this.$router.push("/").catch(() => {});
              break;
          }
          break;

        default:
          this.$router.push("/").catch(() => {});
          break;
      }
    } else {
      this.$router.push("/").catch(() => {});
    }
  },
  computed: {
    session: function () {
      return this.$store.state.session;
    },
  },
};
</script>
